module.exports = __webpack_public_path__ + "assets/f326f2f263b1498fedbe1d07d7254d10.js";